import { autoUpdate, flip, offset as offsetMiddleware, useDismiss, useFloating, useInteractions, } from "@floating-ui/react";
import { useContext, useMemo } from "react";
import { zIndexLayers } from "../../../common/zIndexLayers";
import { UISettingsProvider } from "../../../core/context/UISettingsProvider";
import { USelectContext } from "../context/context";
export const useDropdown = ({ dropdownPlacement, dropdownOffset, size, strategy, onOpenChange, }) => {
    const { showDropdown } = useContext(USelectContext);
    const offset = useMemo(() => {
        return dropdownOffset ?? size === "50" ? 4 : 8;
    }, [size, dropdownOffset]);
    const contextSettings = useContext(UISettingsProvider);
    const placement = dropdownPlacement || contextSettings?.dropdowns?.placement || "bottom-start";
    const { refs, floatingStyles, context } = useFloating({
        open: showDropdown,
        onOpenChange: onOpenChange,
        placement,
        strategy: strategy ?? contextSettings?.dropdowns?.popperOptions?.strategy,
        whileElementsMounted: autoUpdate,
        middleware: [
            offsetMiddleware(offset ?? 10),
            flip({
                fallbackAxisSideDirection: "none",
            }),
        ],
    });
    const dismiss = useDismiss(context, { enabled: true });
    const { getReferenceProps, getFloatingProps } = useInteractions([dismiss]);
    const style = useMemo(() => ({
        ...floatingStyles,
        zIndex: zIndexLayers.dropdown,
    }), [floatingStyles]);
    return {
        getReferenceProps,
        getFloatingProps,
        refs,
        style,
    };
};
